//Include Both Helper File with needed methods

import { save_validate_share_points_creds , share_point_directory_list, share_point_file_save } from "../../helpers/fakebackend_helper";
import { open_success_modal } from "../Success_Modal/reducer";
import { bot_details } from "../thunks";
import { set_sharepoint_creds, set_sharepoint_loader, set_sharepoint_root_files } from "./reducer";




export const Save_Share_Point_Creds = (data) => async (dispatch) => {
    
    
    
    try {
      // console.log(data);
    dispatch(set_sharepoint_loader(true))

    dispatch(set_sharepoint_creds(data))
    
    const sharepoint_root_files = await save_validate_share_points_creds(data)
    
    dispatch(set_sharepoint_root_files(sharepoint_root_files))

    dispatch(set_sharepoint_loader(false))

   
  } catch (error) {

    console.log(error)
    dispatch(set_sharepoint_loader(false))
    
  }



};


export const Get_Share_Point_Files = (data) => async (dispatch) => {
    
    
    
    try {
      // console.log(data);
    dispatch(set_sharepoint_loader(true))

    dispatch(set_sharepoint_creds(data))
    
    const sharepoint_root_files = await share_point_directory_list(data)
    
    dispatch(set_sharepoint_root_files(sharepoint_root_files))

    dispatch(set_sharepoint_loader(false))

   
  } catch (error) {

    console.log(error)
    dispatch(set_sharepoint_loader(false))
    
  }



};



export const Save_Share_Point_File_To_Knowledge = (data) => async (dispatch) => {
    
    
    
    try {
    dispatch(set_sharepoint_loader(true))

  // console.log(data);
  
    
    const sharepoint_root_files = await share_point_file_save(data)


    dispatch(open_success_modal("Files Uploaded Successfully "))
    dispatch(bot_details({Bot_ID:data.get('Bot_ID')}))
    dispatch(set_sharepoint_loader(false))

   
  } catch (error) {
        dispatch(set_sharepoint_loader(false))
    console.log(error)

    
  }



};



